// extracted by mini-css-extract-plugin
export default {"groupLabel":"UserPrivilege_groupLabel__3EsA9","labels":"UserPrivilege_labels__+WbeB","processBox":"UserPrivilege_processBox__a2Uh2"};